import Vue from "vue";
export default new Vue();



// WEBPACK FOOTER //
// ./src/util/bus.js